import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_b_alert = _resolveComponent("b-alert");
  const _component_b_modal = _resolveComponent("b-modal");
  return $props.request ? (_openBlock(), _createBlock(_component_b_modal, {
    key: 0,
    id: "password-verify-modal",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.openModal = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    title: "Confirm Password",
    "ok-title": "Confirm",
    "ok-variant": "success",
    "ok-disabled": $data.loading || !$data.pword || $data.verified,
    size: "md",
    onOk: $options.confirmPassword
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: $data.loading
    }, null, 8, ["loading"]), !$data.loading && !$data.verified ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "alert alert-danger"
    }, [_createElementVNode("p", null, " This action requires you to verify your password before proceeding. ")], -1)), _createVNode(_component_b_form_group, {
      label: "Password",
      class: "mx-5"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_form_input, {
        modelValue: $data.pword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pword = $event),
        type: "password",
        placeholder: "Enter your password",
        ref: "pword",
        required: "",
        autocomplete: "current-password"
      }, null, 8, ["modelValue"])], undefined, true),
      _: 1
    }), _withDirectives(_createVNode(_component_b_alert, {
      variant: "danger"
    }, {
      default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString($data.error), 1)], undefined, true),
      _: 1
    }, 512), [[_vShow, $data.error]])])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_b_alert, {
      variant: "success"
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("p", null, "Password verified successfully!", -1)]))], undefined, true),
      _: 1
    }, 512), [[_vShow, $data.verified]])], undefined, true),
    _: 1
  }, 8, ["modelValue", "ok-disabled", "onOk"])) : _createCommentVNode("", true);
}